"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComputedData = getComputedData;
const getComplexity_1 = require("./getComplexity");
const getFormalCharge_1 = require("./getFormalCharge");
const getHeavyAtomCount_1 = require("./getHeavyAtomCount");
const getHydrogenBondAcceptorCount_1 = require("./getHydrogenBondAcceptorCount");
const getHydrogenBondDonorCount_1 = require("./getHydrogenBondDonorCount");
const getRotableBondCount_1 = require("./getRotableBondCount");
const getTPSA_1 = require("./getTPSA");
const getxLogP3_1 = require("./getxLogP3");
/**
 * Returns an object of computed data
 *
 * @param data Data of a compound data request to the PubChem API
 * @returns Object of computed data
 */
function getComputedData(data) {
    return {
        hydrogenBondDonorCount: (0, getHydrogenBondDonorCount_1.getHydrogenBondDonorCount)(data),
        hydrogenBondAcceptorCount: (0, getHydrogenBondAcceptorCount_1.getHydrogenBondAcceptorCount)(data),
        rotableBondCount: (0, getRotableBondCount_1.getRotableBondCount)(data),
        heavyAtomCount: (0, getHeavyAtomCount_1.getHeavyAtomCount)(data),
        formalCharge: (0, getFormalCharge_1.getFormalCharge)(data),
        complexity: (0, getComplexity_1.getComplexity)(data),
        tpsa: (0, getTPSA_1.getTPSA)(data),
        xLogP3: (0, getxLogP3_1.getxLogP3)(data),
    };
}
//# sourceMappingURL=getComputedData.js.map